import { render, staticRenderFns } from "./BoxHead.vue?vue&type=template&id=312d2474&"
import script from "./BoxHead.vue?vue&type=script&setup=true&lang=js&"
export * from "./BoxHead.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BoxHead.vue?vue&type=style&index=0&id=312d2474&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports